import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Logo';

const footerPlaceholderClass =
  'cursor-pointer border-0 bg-transparent p-0 text-left text-sm text-muted underline-offset-2 transition hover:text-foreground';

export function MarketingFooter() {
  return (
    <footer className="border-t border-border/80 bg-footer-deep px-4 py-14 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mb-10 text-xl">
          <Logo size="md" clickable={false} />
        </div>
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-muted">Product</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/#features" className="text-muted transition hover:text-foreground">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/marketplace" className="text-muted transition hover:text-foreground">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/#features" className="text-muted transition hover:text-foreground">
                  Security
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-muted">Company</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <button type="button" className={footerPlaceholderClass}>
                  About
                </button>
              </li>
              <li>
                <button type="button" className={footerPlaceholderClass}>
                  Blog
                </button>
              </li>
              <li>
                <button type="button" className={footerPlaceholderClass}>
                  Careers
                </button>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-muted">Support</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <button type="button" className={footerPlaceholderClass}>
                  Help Center
                </button>
              </li>
              <li>
                <button type="button" className={footerPlaceholderClass}>
                  Contact
                </button>
              </li>
              <li>
                <button type="button" className={footerPlaceholderClass}>
                  Status
                </button>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-muted">Legal</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <button type="button" className={footerPlaceholderClass}>
                  Privacy Policy
                </button>
              </li>
              <li>
                <button type="button" className={footerPlaceholderClass}>
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>
        </div>
        <p className="mt-12 border-t border-border/60 pt-8 text-center text-sm text-muted">
          © 2026 LognSec LLC. ShieldSME is a product of LognSec LLC.
          <br />
          All rights reserved.
        </p>
      </div>
    </footer>
  );
}
